module.exports = __webpack_public_path__ + "img/student_help_pre_work.57f2b105.jpg";